export const manageDataConstant = {
    IMPORT_DATA_SUCCESS: 'MANAGE_DATA_IMPORT_DATA_SUCCESS',
    DISPLAY_DATA_SUCCESS: 'MANAGE_DATA_DISPLAY_DATA_SUCCESS',
    BUILD_DRUGS_SUCCESS: 'MANAGE_DATA_BUILD_DRUGS_SUCCESS'
};
